import React, { useState } from "react";
import { Button, Dropdown, DropdownItemProps, Form, Grid, Icon, Label } from "semantic-ui-react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useField } from "formik";
import MyHelpButton from "./MyHelpButton";
import AddNewLocationModal from "../../../features/inventory/AddNewLocationModal";
import { useStore } from "../../stores/store";
import { TicketItemFormValues } from "../../models/ticket";
import { PartInventoryFormValues } from "../../models/inventory";

interface Props {
    placeholder: string;
    name: string;
    options: DropdownItemProps[];
    setOptions: (items: DropdownItemProps[]) => void;
    label?: string;
    className?: string;
    showHelp?: boolean;
    helpName?: string;
    onChange?: (value: any) => void;
    showDefaults?: boolean;
    onSetDefaults?: (value: string) => void;
    clearable: boolean;
    value?: string;
    part?: TicketItemFormValues | PartInventoryFormValues;
    closeAddLocation?: (values?: DropdownItemProps) => void;
    hideAdd?: boolean;
}
const InventoryStockLocationSelect = ({
    placeholder,
    name,
    options,
    setOptions,
    label,
    className,
    showHelp,
    helpName,
    onChange,
    clearable,
    part,
    value,
    closeAddLocation,
    hideAdd,
}: Readonly<Props>) => {

    const [inputValue, setInputValue] = useState<string>("");
    const [field, meta, helpers] = useField(name);
    const { modalStore } = useStore();

    return (
        <Form.Field error={meta.touched && !!meta.error}>
            {label && (
                <label htmlFor="autocomplete" className={`${className ?? ""} myLabel`}>
                    {`${label} `}
                    {showHelp && (
                        <MyHelpButton
                            name={`${name}.help`}
                            help={helpName ?? ""}
                            color={"blue"}
                        />
                    )}
                </label>
            )}
            <Grid.Row columns={2}>
                <Grid.Column className={hideAdd ? "w100 noPaddingRight" : "w90 noPaddingRight"}>
                    <Dropdown
                        id="autocomplete"
                        placeholder={placeholder ?? ""}
                        fluid
                        search
                        selection
                        options={options}
                        value={value ? value : field.value ?? ""}
                        onBlur={() => helpers.setTouched(true)}
                        onChange={(e, d) => {
                            helpers.setValue(d.value);
                            setInputValue("");
                            if (onChange) onChange(d.value);
                        }}
                        onSearchChange={(e, data) => setInputValue(data.searchQuery)}
                        onKeyDown={(e: React.KeyboardEvent) => {
                            if (e.key === "Enter" && inputValue.trim()) {
                                // Add input value as a new option and select it
                                helpers.setValue(inputValue.trim());
                                setInputValue(""); // Clear input after adding
                            }
                        }}
                        style={{ width: "100%" }}
                        clearable={clearable ?? false}
                    />
                </Grid.Column>
                {!hideAdd && (
                    <Grid.Column className="w10 noPadding">
                        <Button color="blue" className="w75 h100 justify-content-center align-items-center" type="button"
                            onClick={() =>
                                modalStore.openModal(<AddNewLocationModal closeModal={closeAddLocation} />)
                            }>
                            <Icon name="plus" className="m0" textAlign="center"/>
                        </Button>
                    </Grid.Column>

                )}
            </Grid.Row>
            {meta.touched && meta.error && (
                <Label basic color="red">
                    {meta.error}
                </Label>
            )}
        </Form.Field>
    );
};

export default InventoryStockLocationSelect;
